module.exports = __webpack_public_path__ + "static/media/Roboto-Light.f0fc91f2.woff";